import styles from '../../GeoFenceCreateEdit.module.css'
import { CloseActionProps } from '../../GeoFenceCreateEdit.types'

export const AsideFooter = ({ closeAction }: CloseActionProps) => {
  return (
    <div className={styles.createActions}>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.cancelButton}
          onClick={closeAction}
          data-testid="geofence-cancel"
        >
          Cancel
        </button>
        <button type="submit" className={styles.saveButton} data-testid="geofence-save">
          Save
        </button>
      </div>
    </div>
  )
}
